'use strict';

module.exports = (element, index) => false;